/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".custom-combobox[_ngcontent-%COMP%]{display:inline-block;width:100%;height:calc(1.5em + .75rem + 2px);font-size:1rem;font-weight:400;line-height:1.5;color:#495057;vertical-align:middle;border-radius:.25rem}"];
export { styles as styles };
